// API Configuration
const config = {
  // Determine if we're in development or production
  isDevelopment: process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost',
  
  // API Base URLs
  API_BASE_URL: (() => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    
    // If running on localhost, use localhost backend with correct port
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8080/saininewsite/backend';
    }
    
    // For live domain, check if it's a known domain
    // Replace 'your-domain.com' with your actual domain
    const knownDomains = ['123.techyhub.in/', '123.techyhub.in/'];
    
    if (knownDomains.includes(hostname)) {
      return `${protocol}//${hostname}/saininewsite/backend`;
    }
    
    // Default fallback for any other domain
    return `${protocol}//${hostname}/backend`;
  })(),
  
  // Frontend URLs
  FRONTEND_URL: (() => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return port ? `${protocol}//${hostname}:${port}` : `${protocol}//${hostname}`;
    }
    
    return `${protocol}//${hostname}`;
  })(),
};

export default config;
